// const imgHost = 'http://116.62.245.120/cmscdn/';
const imgHost = '';
// const imgHost = ' http://localhost:8080/';
const isPro = Object.is(process.env.NODE_ENV, 'production')

 
export default {
  imgHost,
  baseUrl: isPro ? 'https://erp.lfwellness.cn' : '/'
}